export const getFileExtension = (fileName: string): string => {
  const parts = fileName.split(".");
  if (parts.length < 2) {
    throw Error("Invalid file name " + fileName);
  }
  return parts[parts.length - 1];
};

export function isImage(fileName: string): boolean {
  var ext = getFileExtension(fileName);
  switch (ext.toLowerCase()) {
    case "jpg":
    case "jpeg":
    case "gif":
    case "bmp":
    case "png":
      return true;
  }
  return false;
}

export function isVideo(fileName: string): boolean {
  var ext = getFileExtension(fileName);
  switch (ext.toLowerCase()) {
    case "m4v":
    case "avi":
    case "mkv":
    case "mov":
    case "3gp":
    case "mpg":
    case "mp4":
      return true;
  }
  return false;
}

export const dataUrlToBase64 = (dataUrl: string): string => {
  let encoded = dataUrl.replace(/^data:(.*,)?/, "");
  if (encoded.length % 4 > 0) {
    encoded += "=".repeat(4 - (encoded.length % 4));
  }
  return encoded;
};

export function getDataUrl(file: File): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      const res = reader.result;
      if (res) {
        let encoded = reader.result.toString();
        resolve(encoded);
      } else {
        reject("No result was found from the file");
      }
    };
    reader.onerror = (error) => {
      console.log("error de carga a dataUrl", error);
      reject(error);
    };
  });
}

export interface Archivo {
  contenidoBase64: string;
  contenidoDataUrl?: string;
  tipo: string;
  nombre: string;
}

export interface RespuestaArchivo {
  contenido: string;
  nombre?: string;
  extension?: string;
  fecha: string;
}

export const fileToArchivo = async (file: File): Promise<Archivo> => {
  const dataUrl = await getDataUrl(file);
  const base64 = dataUrlToBase64(dataUrl);
  const archivo: Archivo = {
    contenidoDataUrl: dataUrl,
    contenidoBase64: base64,
    nombre: file.name,
    tipo: file.type,
  };
  return archivo;
};
